import { CSSProperties } from 'react';
import { Text } from '~/commonComponents/Text';
import { Colors } from '~/themes/colors';

interface IValueProps {
  text: string;
  style?: CSSProperties;
}

export const Value = ({ text, style }: IValueProps) => (
  <Text
    color={Colors.neutral_600}
    data-testid="input-job.field.value"
    overflow="hidden"
    textOverflow="ellipsis"
    whiteSpace="nowrap"
    style={{
      maxWidth: 240,
      ...style,
    }}
  >
    {text}
  </Text>
);
